import { gameNamesDesktop } from "abstract/constants/game-ids"

export interface GameOption<T = string | number> {
  value: T
  label: string
}

export const getGameOptions = (): GameOption<string>[] => {
  return Object.entries(gameNamesDesktop).map(([gameId, gameName]) => ({
    value: gameId,
    label: `${gameId} - ${gameName}`,
  }))
}

export const getGameOptionsWithNumberValues = (): GameOption<number>[] => {
  return Object.entries(gameNamesDesktop).map(([gameId, gameName]) => ({
    value: Number(gameId),
    label: `${gameId} - ${gameName}`,
  }))
}
